export default "__VITE_ASSET__ChHiONt0__"